// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SimplePaperPodcast-cls1__b5dc59268661f21ed085{/*!*/}.SimplePaperPodcast-cls2___1b3e31f24f16df780bb{display:flex;align-items:center;grid-gap:12px;gap:12px;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SimplePaperPodcast-cls1__b5dc59268661f21ed085",
	"cls2": "SimplePaperPodcast-cls2___1b3e31f24f16df780bb SimplePaperPodcast-cls1__b5dc59268661f21ed085"
};
export default ___CSS_LOADER_EXPORT___;
